import { SafeDictionary } from "@insite/client-framework/Common/Types";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import isDate from "lodash/isDate";

/**
 * To convert string to boolean
 * @param value
 */
export const parseBoolean = (value?: string) => (value ? value?.toLowerCase() === "true" : false);

/**
 * To Check if the user has a role
 * @param value
 */
export const hasRole = (roles: string, role: string, onlyProvidedRole?: boolean) => {
    if (!roles) {
        return false;
    }
    if (!onlyProvidedRole) {
        return roles.includes(role);
    }
    return roles.includes(role) && roles.split(",").length === 1;
};

export const parseDate = (date: string | null | undefined) => {
    if (!date) {
        return "";
    }
    const substr = date.substring(0, date.indexOf("T"));
    return getUTCDate(new Date(substr));
};

export const getUTCDate = (date: Date) => {
    const fullYear = date.getUTCFullYear();
    const month = date.getUTCMonth() + 1;
    const day = date.getUTCDate();

    return `${month < 10 ? `0${month}` : month}/${day}/${fullYear}`;
};

/**
 * This function finds the uuid for the generated marketo forms that lives in modals.
 * @param modalFormsData SafeDictionary<{ formId: string; uuid: string } (from the state)
 * @param formId
 * @returns string
 */
export const getMarketoFormUuidByFormId = (
    modalFormsData: SafeDictionary<{ formId: string; uuid: string }>,
    formId: string,
) => {
    let uuid = "";
    const keys = Object.keys(modalFormsData);
    if (keys.length === 0) {
        return uuid;
    }

    keys.forEach((key: string) => {
        if (modalFormsData[key]?.formId === formId) {
            uuid = modalFormsData[key]?.uuid as string;
        }
    });

    return uuid;
};
export const isMobileScreen = () => typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches;
export const isTabletScreen = () => typeof window !== "undefined" && window.matchMedia("(max-width: 1024px)").matches;
